import React, { useEffect, useState } from "react";
import FlavorTabShimmer from "../FlavorTabShimmer";
import DragAndDropList from "./CreativesDrogAndDrop";
import CreativesSelectableTableRows from "./CreativesSelectableTableRows";
export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  result.forEach((item, index) => {
    item.intBannerOrder = index + 1;
  });

  return result;
};
const NonMandatoryPromotions = ({
  loading,
  handleDelete,
  handleEdit,
  IsAdmin,
  promotionsList,
  handleCreativeSelect = () => {}
}) => {
  const [itemList, setItemList] = useState([]);

  useEffect(() => {
    setItemList(promotionsList);
  }, [promotionsList]);

  const onDragEnd = (result) => {
    if (!result.destination) {
      return; // Dragged outside the list
    }

    const updatedItems = reorder(
      itemList,
      result.source.index,
      result.destination.index
    );

    setItemList(updatedItems);
  };


  return (
    <div>
      <div className="px-6 sm:px-0">
        {loading ? (
          <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4">
            <FlavorTabShimmer />
            <FlavorTabShimmer />
            <FlavorTabShimmer />
            <FlavorTabShimmer />
            <FlavorTabShimmer />
            <FlavorTabShimmer />
          </div>
        ) : (
          IsAdmin ?
          <>
            {promotionsList?.length > 0 ?
            <DragAndDropList
              promotionsList={itemList}
              handleDelete={handleDelete}
              handleEdit={handleEdit}
              dragAndDrop={true}
              onDragEnd={onDragEnd}
              type={'non-mandatory'}
              IsAdmin={IsAdmin}
                  /> : <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "10vh",
                      fontSize: "16px",
                      color: "gray",
                    }}
                  >
                    No Promotions Available
                  </div>}
          </>
            : <>
              <CreativesSelectableTableRows
                promotionsList={itemList}
                handleCreativeSelect={handleCreativeSelect}
              />
            </>
        )}
      </div>
    </div>
  );
};

export default NonMandatoryPromotions;
